import { render, staticRenderFns } from "./Bubbles.vue?vue&type=template&id=e4ce20a6&scoped=true"
import script from "./Bubbles.vue?vue&type=script&lang=ts"
export * from "./Bubbles.vue?vue&type=script&lang=ts"
import style0 from "./Bubbles.vue?vue&type=style&index=0&id=e4ce20a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.bun/vue-loader@15.11.1+cf975d9100cf2460/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ce20a6",
  null
  
)

export default component.exports